var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"full-width-container"},[(_vm.loggedIn)?_c('Settings'):_vm._e(),(!_vm.loggedIn)?_c('Auth'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }